import fetchMethodList from "../services/fetchMethodList";
import fetchLastUsedMethod from "../services/fetchLastUsed";
import fetchBankListData from "../services/fetchBankList";
import fetchUserPromo from "../services/fetchUserPromo";
import getSummary from "../services/getSummary";
import fetchWalletBalance from "../services/fetchWalletBalance";
import fetchPromoList from "../services/fetchPromoList";
import {
  createFetchPromoRequestBody,
  createMethodRequestBody,
  createPromoValidationRequestBody,
  createSummaryRequestBody,
  createUserPromoRequestBody,
  fetchVendorData,
} from "./common";
import { validatePromo } from "../services/validatePromo";

async function fetchWallet({ origin, itemDetails }) {
  const { vendorId } = fetchVendorData(origin.source);
  const body = { category_id: vendorId, item_details: itemDetails };
  const { response } = await fetchWalletBalance(body);
  if (response) {
    return { walletBalance: response };
  }
  return null;
}
async function fetchBankList({ origin }) {
  const { vendorId } = fetchVendorData(origin.source);
  const { response } = await fetchBankListData(vendorId);
  if (response) {
    return { bankList: response };
  }
  return null;
}
async function fetchList({ finalAmount, origin, itemDetails }) {
  const body = await createMethodRequestBody({ origin, itemDetails });
  const { response } = await fetchMethodList(body, finalAmount);
  if (response) {
    const result: any = { methodList: response.allMethods ?? [] };
    if (response?.autoPayMethods?.length) {
      result.autoPay = {
        isAvailable: true,
        methodData: response.autoPayMethods,
      };
    }
    return result;
  }
  return null;
}
async function fetchLastUsed({ finalAmount, origin, itemDetails }) {
  const body = await createMethodRequestBody({ origin, itemDetails });
  const { response } = await fetchLastUsedMethod(body, finalAmount);
  if (response?.paymentPartner) {
    return {
      lastUsed: response,
      selectedMethod: response,
    };
  }
  return null;
}
async function fetchSummary({
  finalAmount,
  origin,
  itemDetails,
  promo,
  appliedPromo,
  invalidPromoMsg,
  tip,
  addOns,
  selectedMethod,
  wallet,
  walletBalance,
  fullfilmentDetails,
}) {
  const body = createSummaryRequestBody({
    origin,
    itemDetails,
    promo,
    appliedPromo,
    invalidPromoMsg,
    tip,
    addOns,
    selectedMethod,
    finalAmount,
    wallet,
    walletBalance,
    fullfilmentDetails,
  });
  const { response } = await getSummary(body);
  if (response) {
    return { summary: response };
  }
  return null;
}

async function fetchAutoApplyPromo({
  finalAmount,
  origin,
  amount,
  itemDetails,
  selectedMethod,
  wallet,
  walletBalance,
}) {
  const body = createUserPromoRequestBody({
    origin,
    amount,
    itemDetails,
    selectedMethod,
    finalAmount,
    wallet,
    walletBalance,
  });
  const { response } = await fetchUserPromo(body);
  if (response) return response;
  return null;
}

async function fetchPromo({
  finalAmount,
  origin,
  amount,
  itemDetails,
  selectedMethod,
  wallet,
  walletBalance,
  appliedPromo,
}) {
  const body = createFetchPromoRequestBody({
    origin,
    amount,
    itemDetails,
    selectedMethod,
    finalAmount,
    wallet,
    walletBalance,
  });
  const { response, error } = await fetchPromoList(body);
  if (appliedPromo?.code) {
    const idx = response.findIndex((item) => item.code === appliedPromo.code);
    if (idx > -1) response.unshift(response.splice(idx, 1)[0]);
  }
  return { response, error };
}

async function validatePromoCode({
  origin,
  amount,
  finalAmount,
  code,
  selectedMethod,
  wallet,
  walletBalance,
  itemDetails,
  additionalData = {},
}) {
  const body = await createPromoValidationRequestBody({
    origin,
    amount,
    finalAmount,
    code,
    selectedMethod,
    wallet,
    walletBalance,
    itemDetails,
    additionalData,
  });
  return await validatePromo(body);
}

export {
  fetchWallet,
  fetchBankList,
  fetchList,
  fetchLastUsed,
  fetchSummary,
  fetchAutoApplyPromo,
  fetchPromo,
  validatePromoCode,
};
